import { render, staticRenderFns } from "./category-menu-group.vue?vue&type=template&id=6de5b7b9&scoped=true&"
import script from "./category-menu-group.vue?vue&type=script&lang=js&"
export * from "./category-menu-group.vue?vue&type=script&lang=js&"
import style0 from "./category-menu-group.vue?vue&type=style&index=0&id=6de5b7b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5b7b9",
  null
  
)

export default component.exports